import { gql } from 'graphql-request'

export const appSubscriptionFragment = gql`
  fragment appSubscriptionType on appSubscription {
    id
    referenceId
    status
    planType
    createdAt
    startedAt
    canceledAt
    pausedAt
    nextBilledAt
    firstBilledAt
    frequency
    interval
    customData
  }
`
